import { Kategorie, Zutat, useAddKategorieMutation, useListKategorienQuery, useListZutatenQuery, useRemoveKategorieMutation, zutatenApi } from "./zutatenConnector"
import "./ZutatenComponent.css"
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useAppDispatch } from "../../app/hooks";

function groupBy<T, TKey>(iterable: T[], mapper: (item: T) => TKey) {
    if (iterable === null || iterable === undefined)
        return iterable;

    const map = new Map<TKey, T[]>();
    for (const item of iterable) {
        const key = mapper(item);
        const existingList = map.get(key);
        if (existingList === undefined)
            map.set(key, [item]);
        else
            existingList.push(item);
    }
    return map;
}

export function ZutatenListComponent() {
    const { data: zutaten } = useListZutatenQuery();
    const { data: kategorien } = useListKategorienQuery();

    const zutatenNachKategorie = groupBy(zutaten ?? [], x => x.kategorie);

    if (!zutaten || !kategorien) return <></>

    return <>
        <div />
        <div className="main-content">
            <h2>Zutaten</h2>
            <DndProvider backend={HTML5Backend}>
                <div className="kategorien-columns">
                    {kategorien.map(kat => <KategorienSublist key={kat.id} kategorie={kat} zutaten={zutatenNachKategorie.get(kat.id) ?? []} />)}
                    <KategorienSublist key="null" kategorie={null} zutaten={zutatenNachKategorie.get(null) ?? []} />
                </div>
            </DndProvider>
            <KategorieHinzufügenButton />
        </div>
    </>
}

function KategorienSublist(props: { kategorie: Kategorie | null, zutaten: Zutat[] }) {
    const { kategorie, zutaten } = props;
    const dispatch = useAppDispatch();
    const [, drop] = useDrop({
        accept: ["zutat", "kategorie"],
        drop: async (item: Zutat | Kategorie) => {
            if ("kategorie" in item)
                await dispatch(zutatenApi.endpoints.setKategorie.initiate({ zutatId: item.id, kategorie: kategorie?.id ?? null }))
            else {
                let sortId = kategorie?.sort_id;
                if (sortId === undefined) {
                    const kategorien = await dispatch(zutatenApi.endpoints.listKategorien.initiate());
                    const maxSortId = kategorien.data?.map(x => x.sort_id).filter(x => x !== item.sort_id).reduce((a, b) => Math.max(a, b), 0);
                    console.log(kategorien?.data, kategorien.data?.map(x => x.sort_id).filter(x => x !== item.sort_id), item.sort_id);
                    if (!maxSortId) return;
                    sortId = maxSortId + 1;
                }
                await dispatch(zutatenApi.endpoints.setKategorieSortId.initiate({ id: item.id, sortId }))
            }
        }
    }, [kategorie]);
    const [, drag] = useDrag({
        type: "kategorie",
        item: kategorie
    }, [kategorie])

    return <div ref={e => { drop(e) }}>
        {zutaten.length === 0 && kategorie && <KategorieLoeschenButton kategorie={kategorie} />}
        <h3 ref={e => { drag(e) }} onDoubleClick={() => {
            if (!kategorie) return;
            const newName = prompt(`Bitte geben Sie einen neuen Namen für ${kategorie.name} ein:`, kategorie.name);
            if (!newName) return;
            dispatch(zutatenApi.endpoints.setKategorieName.initiate({ id: kategorie.id, name: newName }))
        }}>
            {kategorie?.name ?? "Unsortiert"}
        </h3>
        <div className="zutaten-sublist">
            {zutaten.map(zutat => <KategorieZutat key={zutat.id} zutat={zutat} />)}
        </div>
    </div>
}

function KategorieZutat(props: { zutat: Zutat }) {
    const { zutat } = props;
    const [, drag] = useDrag({
        type: "zutat",
        item: zutat
    }, [zutat]);
    return <div ref={e => { drag(e) }} className="zutat-draggable">{zutat.name}</div>
}

function KategorieHinzufügenButton() {
    const [addKategorie] = useAddKategorieMutation();
    const onClick = () => {
        const name = prompt("Name der Kategorie:");
        if (name)
            addKategorie({ name });
    }
    return <button onClick={onClick}>Kategorie hinzufügen</button>
}

function KategorieLoeschenButton(props: { kategorie: Kategorie }) {
    const [removeKategorie] = useRemoveKategorieMutation();
    return <button className="kategorie-loeschen-button" onClick={() => window.confirm(`Sind Sie sich sicher, dass die Kategorie "${props.kategorie.name}" gelöscht werden soll?`) && removeKategorie({ id: props.kategorie.id })}>X</button>
}
